import { useId, useState } from "react";
import { Icons } from "assets/svgs";
import { ErrorMessage } from "common";
import { InputText } from "primereact/inputtext";

const inputType = {
  text: "text",
  password: "password",
};

export const PrimaryInput = ({
  //TODO: Refactor to work with type
  isPasswordInput,
  placeholder,
  showBorder = false,
  label,
  className,
  register,
  error,
  icon,
  wrapperClassName,
  labelClassName,
  ...rest
}) => {
  const [type, setType] = useState(inputType.password);
  const generatedId = useId();
  const inputId = rest?.id || rest?.name || register?.name || generatedId;

  const changeType = () => {
    setType(type === inputType.text ? inputType.password : inputType.text);
  };

  return (
    <div className={`flex flex-col w-100 gap-2 primary-100 relative ${wrapperClassName}`}>
      <div>
        <label className={"text-[#667085] font-montserrat font-semibold text-[12px] leading-4"} htmlFor={inputId}>
          {label}
        </label>
        <div className="relative">
          {icon ? <span className="absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none">{icon}</span> : null}
          <InputText
            {...register}
            {...rest}
            className={`w-full !bg-[#FFF8F8] !border-b placeholder:!text-[#A0A5AF] border-[#D9D9D9] !font-sans !font-normal !py-2 !text-[14px] leading-5 ${
              icon ? "!pl-8 !pr-0" : "!px-0"
            } ${className} ${error ? "border-red-500" : ""} ${
              showBorder
                ? "!rounded-[6px] !border-[1px] !border-[#D9D9D9] hover:enabled:!border-transparent"
                : "!border-0 !rounded-none"
            }`}
            id={inputId}
            placeholder={placeholder}
            style={{ fontFamily: "Montserrat, sans-serif" }}
            type={isPasswordInput ? type : "text"}
          />
        </div>
      </div>
      {isPasswordInput ? (
        <div className="cursor-pointer absolute right-2" style={{ top: error ? "12px" : "14px" }}>
          {type === inputType.password ? (
            <Icons.ShowPasswordIcon onClick={changeType} />
          ) : (
            <Icons.HidePassword onClick={changeType} />
          )}
        </div>
      ) : null}

      {error ? <ErrorMessage>{error?.message}</ErrorMessage> : null}
    </div>
  );
};
